import React, {lazy} from 'react';
import {Redirect} from 'react-router-dom';
import GuestGuard from "../components/GuestGuard";
import OnboardingGuard from "../components/OnboardingGuard";

const authRoutes = [
    {
        exact: true,
        guard: OnboardingGuard,
        path: '/onboarding/continue',
        component: lazy(() => import('../OnBoardingScreen/pages/ContinueOnboarding'))
    },
    {
        exact: true,
        guard: OnboardingGuard,
        path: '/onboarding',
        component: lazy(() => import('../OnBoardingScreen/OnBoarding.js'))
    },
    // Legacy login is disabled for now; old links land on onboarding.
    // To restore: component: lazy(() => import('../views/Login')) with guard GuestGuard.
    {
        exact: true,
        path: '/login',
        component: () => <Redirect to="/onboarding"/>
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/app-download',
        component: lazy(() => import('../views/AppDownload'))
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/rfd/products/:productId',
        component: lazy(() => import('../views/TataQl'))
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/rfd/products/payments/:Id',
        component: lazy(() => import('../views/TataQl/CheckOut'))
    }
];

export default authRoutes;
